import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";

export class OrganizerSchemaDataModel extends BaseSchemaDataModel {
}

export class OrganizerSchemaModel extends BaseSchemaModel {
  model: OrganizerSchemaDataModel;

  constructor(model: OrganizerSchemaModel) {
    super(SCHEMA_TYPE.thing, model.name, model.url);

    this.model = model;
  }

  get typeParams(): String {
    return this.type ? `"@type":"${this.type}"` : ``;
  }

  toString(): String {
    return `${this.typeParams}${this.nameParams}${this.urlParams}`;
  }
}
